import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { captureException } from './sentry';

/**
 * Reemplaza al ErrorHandler por defecto de Angular para que los errores no manejados lleguen
 * a Sentry.
 *
 * Es el equivalente de Sentry.createErrorHandler() de @sentry/angular, escrito a mano porque
 * este proyecto carga el SDK como asset (ver sentry.ts) y no tiene @sentry/angular instalado.
 */
@Injectable()
export class SentryErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    const ORIGINAL = this.unwrap(error);

    // Mismo formato que el ErrorHandler por defecto de Angular, que imprime los dos. Sin la
    // segunda linea se pierde de la consola el error de verdad, que es donde se depura.
    console.error('ERROR', error);
    if (ORIGINAL !== error) { console.error('ORIGINAL ERROR', ORIGINAL); }

    // Los errores del API los reporta AppInterceptor, que ademas conoce la peticion
    if (ORIGINAL instanceof HttpErrorResponse) { return; }

    captureException(ORIGINAL);
  }

  /**
   * Angular envuelve el error original antes de entregarlo; Sentry necesita el Error de verdad
   * para poder armar el stack trace.
   */
  private unwrap(error: any): any {
    if (error && error.ngOriginalError) { return error.ngOriginalError; }
    if (error && error.rejection) { return error.rejection; } // promesas rechazadas, via zone.js

    return error;
  }
}
